<template>
  <div>
    <div class="addLittleNavPadding d-inline-block d-md-none">
    </div>
    <div class="addBigNavPadding d-none d-md-inline-block">
    </div>

    <nav role="navigation" class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top" :class="{'minimized': minimized, 'pt-3': !minimized, 'pt-1': minimized}">
      <div class="container-fluid">

        <div class="justify-content-start">
          <a class="navbar-brand" href="#">
            <img src="../../assets/orange-logo.svg" class="d-inline-block align-bottom mr-3" width="50" height="50" role="img" alt="DAGOBAH" loading="lazy">
            <span class="h1 m-0 text-primary">DAGOBAH</span>
          </a>
          <span class="navbar-text text-left pb-1 d-none d-xl-inline-block">
            {{ $t('navbar-text-part-1') }}
            <br />{{ $t('navbar-text-part-2') }}
          </span>
        </div>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto">
            <li class="nav-item">
              <router-link class="nav-link" aria-current="page" to="/">{{ $t('navbar-home-button') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :class="{ 'disabled': signedUser === undefined }" to="/projects">{{ $t('navbar-projects-button') }}</router-link>
            </li>
            <li v-if="SHOW_STATUS_NAVIGATION_BUTTON" class="nav-item">
              <router-link class="nav-link"  to="/status">{{ $t('navbar-status-button') }}</router-link>
            </li>
            <li class="nav-item" v-if="signedUser === undefined">
              <router-link class="nav-link" to="/registerOrLogin">{{ $t('navbar-register-or-login-button') }}</router-link>
            </li>
            <li class="nav-item dropdown" v-if="signedUser !== undefined" >
              <span type="button" class="nav-link dropdown-toggle d-flex align-items-center py-1" data-toggle="dropdown">
                <span class="svg-avatar mr-1" aria-hidden="true"></span>
                <span class="mr-1">{{ signedUser }}</span>
              </span>
              <ul class="dropdown-menu dropdown-menu-right">
                <li class="d-none"><a class="dropdown-item px-2" href="#">Preferences (coming soon)</a></li>
                <li class="dropdown-item px-2 clickable" v-on:click="logoutUser">
                  <span class="">{{ $t('navbar-logout-button') }}</span>
                </li>
              </ul>
            </li>
            <li class="nav-item d-none">
              <!-- NOT displayed: only here to disable CSS for last nav-link -->
              <router-link class="nav-link" to="/about">{{ $t('navbar-register-or-login-button') }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div>
        <MessageDisplayer></MessageDisplayer>
      </div>
    </nav>
  </div>
</template>

<script>

import MessageDisplayer from './MessageDisplayer.vue'

export default {
  name: "NavigationBar",
  components: {
    MessageDisplayer,
  },
  props: ["minimized"],
  data() {
    return {
      SHOW_STATUS_NAVIGATION_BUTTON: false
    };
  },
  mounted() {
  },
  computed: {
    signedUser: function() {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    }
  },
  methods: {
    logoutUser() {
      this.$store.commit('logout');
    }
  }
}
</script>

<style scoped>
.addBigNavPadding {
  margin-top: 95px;
}

.addLittleNavPadding {
  margin-top: 45px;
}

.clickable {
  cursor: pointer
}

.nav-item.dropdown.show > .nav-link > .svg-avatar::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='1250' height='1250'%3e%3cpath d='M603.75 94.5c-85.75 9-156.625 61.625-188.375 139.875-7.25 17.625-12 34.75-13.75 49.375-.375 3.125-1.125 8.125-1.625 11.25-1.125 6-.75 46 .625 54.375C405.25 380 417.75 414.25 433.25 438.5c13.625 21.125 33 42.625 52.375 57.75 63.625 49.875 151 61.25 225.625 29.625 74.5-31.625 126.5-100.75 135.875-180.875 1.75-14.875 1-48.375-1.375-62.375-6.375-36.875-20.75-70.625-42.5-99.5-9-11.75-30.75-34-41.375-42.125-32.25-24.5-70.375-40.25-109.125-45.375-11.125-1.375-39.75-2.125-49-1.125z' fill='%23f16e00'/%3e%3cpath d='M418.125 532.75c-22.75 14.25-41.75 29.125-58 45.875-43.375 44.75-70.125 100.5-78.25 163.875-1.375 10.5-1.625 42.375-1.375 160.625.25 135.875.375 148.125 2.375 155.625C286.25 1071 290 1081.125 294 1088.625c18.625 34.5 48 56.625 86 65 11.875 2.5 13 2.5 299.75 2.625h287.875l-.5-205.25c-.125-113-.75-206.75-1.125-208.5-.5-1.75-1.5-7.375-2.25-12.5-6.5-44.25-27.75-92.5-57.125-129.625-16.25-20.625-39-42-60.125-56.375-12.75-8.75-23.625-15.25-25.375-15.25-.625 0-3.375 2-6 4.375-31.75 29.375-76.5 53.125-121.125 64.25-25.125 6.375-39.625 8.125-67.125 8.125-33.875.125-53.25-2.25-81.125-10-26.875-7.5-61.75-23.625-81.375-37.375-12-8.5-23.75-17.625-29.75-23.125-3.75-3.375-7.625-6.25-8.5-6.125-1 0-4.5 1.75-8 3.875z' fill='%23f16e00'/%3e%3c/svg%3e");
}

.navbar.minimized .navbar-nav .dropdown-menu {
  top: 2.5rem;
}

.navbar:not(.minimized) .navbar-nav .dropdown-menu {
  top: 3rem;
}

</style>